
import { AppProviders } from "./components/AppProviders";
import { AppRoutes } from "./components/routing/AppRoutes";

function App() {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}

export default App;
